// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promo-sub-tabs {
  background-color: var(--ion-color-secondary);
  width: 330px;
  margin: auto;
  border-radius: 25px;
  /* Style for segmented buttons*/
  /* Material Design styles */
  /* iOS styles */
}
@media screen and (max-width: 370px) {
  .promo-sub-tabs {
    width: 300px;
  }
}
@media screen and (min-width: 768px) {
  .promo-sub-tabs {
    width: 450px;
  }
}
.promo-sub-tabs ion-segment-button {
  --indicator-color: var(--ion-color-light);
  font-weight: 800;
}
@media screen and (max-width: 768px) {
  .promo-sub-tabs ion-segment-button {
    font-size: 11px;
  }
}
.promo-sub-tabs ion-segment-button::before {
  border-left: none;
}
.promo-sub-tabs ion-segment-button.md {
  --color: var(--ion-color-light);
  --color-checked: var(--ion-color-secondary);
  --indicator-height: 4px;
}
.promo-sub-tabs ion-segment-button.ios {
  --color: var(--ion-color-light);
  --color-checked: #3C83BC;
  --border-radius: 20px;
}

.mobile-promotions {
  background-color: var(--ion-color-light);
}
.mobile-promotions .no-offers {
  color: #fff;
  height: 100px;
  padding-top: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/promotions/promotions-list/promotions-list.component.scss"],"names":[],"mappings":"AAAA;EACE,4CAAA;EACA,YAAA;EAQA,YAAA;EACA,mBAAA;EAEA,+BAAA;EAYA,2BAAA;EAOA,eAAA;AAxBF;AALE;EAHF;IAII,YAAA;EAQF;AACF;AAPE;EANF;IAOI,YAAA;EAUF;AACF;AAJE;EACE,yCAAA;EACA,gBAAA;AAMJ;AALI;EAHF;IAIM,eAAA;EAQN;AACF;AALE;EACE,iBAAA;AAOJ;AAJE;EACE,+BAAA;EACA,2CAAA;EACA,uBAAA;AAMJ;AAFE;EACE,+BAAA;EACA,wBAAA;EACA,qBAAA;AAIJ;;AADA;EACE,wCAAA;AAIF;AAHE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AAKJ","sourcesContent":[".promo-sub-tabs {\r\n  background-color: var(--ion-color-secondary);\r\n  width: 330px;\r\n  @media screen and (max-width: 370px) {\r\n    width: 300px;\r\n  }\r\n  @media screen and (min-width: 768px) {\r\n    width: 450px;\r\n  }\r\n\r\n  margin: auto;\r\n  border-radius: 25px;\r\n\r\n  /* Style for segmented buttons*/\r\n  ion-segment-button {\r\n    --indicator-color: var(--ion-color-light);\r\n    font-weight: 800;\r\n    @media screen and (max-width: 768px) {\r\n        font-size: 11px;\r\n      }\r\n  }\r\n\r\n  ion-segment-button::before {\r\n    border-left: none;\r\n  }\r\n  /* Material Design styles */\r\n  ion-segment-button.md {\r\n    --color: var(--ion-color-light);\r\n    --color-checked: var(--ion-color-secondary);\r\n    --indicator-height: 4px;\r\n  }\r\n\r\n  /* iOS styles */\r\n  ion-segment-button.ios {\r\n    --color: var(--ion-color-light);\r\n    --color-checked: #3C83BC;\r\n    --border-radius: 20px;\r\n  }\r\n}\r\n.mobile-promotions {\r\n  background-color:var(--ion-color-light);\r\n  .no-offers {\r\n    color: #fff;\r\n    height: 100px;\r\n    padding-top: 40px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
